import React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { papCategories } from '../../../constants/postad';

const Footer = loadable(p => import(`@quikr/ui/theme/${p.host}/components/Footer`));

const CopyRight = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  padding: 24px 0;
  @media screen and (max-width: 768px) {
    padding: 24px 12px;
  }
`;

const CopyrightFooter = () => {
  return (
    <CopyRight className="dF jcC fwM">
      Copyright © 2008 - {new Date().getFullYear()} Quikr India Private Limited
    </CopyRight>
  );
};

const FooterWrapper = ({ host }) => {
  const { pathname } = useLocation();
  const renderFooter = () => {
    return (
      <Switch>
        <Route exact path="/post-ad" component={CopyrightFooter} />
        <Route
          exact
          path={`/post-ad/:category(${papCategories})/:subcat([a-zA-Z-]+)`}
          component={CopyrightFooter}
        />
        <Route exact path="/upgrade-ad" render={() => <Footer host={host} />} />
        <Route exact path="/" render={() => <Footer host={host} />} />
      </Switch>
    );
  };
  return renderFooter(pathname);
};

export default FooterWrapper;
